import { useState, useEffect } from 'react';
import { BsBell } from 'react-icons/bs';

import BayTooltip from '../../BayTooltip';
import { StyledNavButton, StyledBadge } from '../styles/navStyles';

interface NotifyButtonProps {
	itemCount?: number;
	toggleFunc: () => void;
}

const NotifyButton = ({ itemCount, toggleFunc }: NotifyButtonProps) => {
	const [bellAnimate, setBellAnimate] = useState(false);
	const [showCount, setShowCount] = useState(false);

	useEffect(() => {
		// Show count after a delay (1.2s)
		const countTimer = setTimeout(() => {
			setShowCount(true);
		}, 1200);

		// Recurring wiggle every 5 seconds
		const wiggleInterval = setInterval(() => {
			setBellAnimate(true); // Reset animation
			setTimeout(() => {
				setBellAnimate(false);
			}, 4000); // Restart wiggle
		}, 5000);

		return () => {
			clearTimeout(countTimer);
			clearInterval(wiggleInterval);
		};
	}, []);

	return (
		<BayTooltip overlay={<span>Notifications</span>} placement="bottom">
			<StyledNavButton
				className={`notification-button bell-animation ${bellAnimate ? 'animate' : ''}`}
				onClick={toggleFunc}
			>
				<BsBell size={16} />
				{showCount && (
					<StyledBadge className="number-notify">{itemCount}</StyledBadge>
				)}
			</StyledNavButton>
		</BayTooltip>
	);
};

export default NotifyButton;
